import type { ButtonHTMLAttributes, MouseEvent } from 'react';

import { ArrowDownIcon } from '@/ui/Icons/ArrowDownIcon';

import { classNames } from '@/utils/classnames';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading: boolean;
  direction: 'normal' | 'reverse';
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

export const SwitchTokensButton = ({ isLoading, direction, onClick }: Props) => {
  return (
    <div className="mx-auto [will-change:transform]" data-loading={isLoading}>
      <span
        aria-hidden={true}
        className={classNames(
          'pointer-events-none absolute -top-[0.5px] -left-[0.5px] size-[33px] rounded-full -z-1',
          'transition-opacity duration-200 animate-[spin_0.7s_linear_infinite]',
          'bg-conic-[var(--token-color-gray-300)_0deg,var(--primitives-color-gray-600)_45deg,var(--token-color-gray-300)_90deg]',
          isLoading ? 'opacity-100' : 'opacity-0',
        )}
      />
      <button
        className={classNames(
          'relative z-1 flex items-center justify-center rounded-full bg-transparent border border-token-gray-300 text-token-gray-1600 size-8',
          'transition-transform duration-200 disabled:opacity-40 active:[transform:scale(.97)] hover:border-token-gray-500',
          'focus-visible:outline-token-gray-500 focus-visible:outline-2',
          { 'border-0': isLoading },
        )}
        disabled={isLoading}
        data-direction={direction}
        onClick={onClick}
      >
        <ArrowDownIcon />
      </button>
      <span
        aria-hidden={true}
        className="pointer-events-none absolute top-px left-px size-7.5 rounded-full [background:radial-gradient(var(--token-color-special-background-card)),_var(--token-color-special-background-app)]"
      />
    </div>
  );
};
